<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display:flex;justify-content:flex-start;align-items:center;">
        <button-add @click="toAddPage" v-if="permissionCodes.indexOf('036010001') !== -1"></button-add>
        <button-delete @deleteSelection="deleteSelection" v-if="permissionCodes.indexOf('036010003') !== -1"/>
        <button-upload :cathUrl="uploadUrl" @getpage="getPage" :onSuccess="onUploadSuccess" value="导入" v-if="permissionCodes.indexOf('036010004') !== -1"/>
      </div>
    <div style="display: flex;justify-content: space-between">
      <input-search  placeholder="物资编号/物资名称"  @search="searchKey" />
      <button-export
        :href="exportUrl"
        :beforeDownload="beforeDownload"
        style="margin: 0 0 0 8px"
        download="download.xls"
        v-if="permissionCodes.indexOf('036010005') !== -1"
        value="导出"/>
    </div>
        </div>
    <table-main :tableHead="tableHead" :tableData="tableData" :operationArr="operationArr" @deleteLine="deleteLine" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" @changePagination="changePagination" :total="total" @goToModifyPage="goToModifyPage" @changeSelection="changeSelection"/>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/Material";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";
import ButtonAdd from "../../../components/common/buttons/button-add";
import { nAlert, nSuccess } from "../../../utils/notice";

export default {
  components: {
    ButtonAdd,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    Breadcrumb
  },
  name: "material-category-manage",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "物资管理",
          name: "material-manage"
        },
        {
          value: "物资管理"
        }
      ],
      fixTypeList: [],
      tableHead: [
        {
          prop: "code",
          label: "物资编号"
        },
        {
          prop: "materialsName",
          label: "物资名称"
        },
        {
          prop: "specification",
          label: "规格型号"
        },
        {
          prop: "measureUnit",
          label: "计量单位"
        },
        {
          prop: "memo",
          label: "备注"
        }
      ],
      tableData: [],
      operationArr: ["modify", "delete"],
      requestData: {
        searchKey: "",
        pageSize: 10,
        pageNum: 1
      },
      uploadUrl: "",
      exportUrl: "",
      total: 0,
      selectionArr: []
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
    this.uploadUrl = api.importManager;
  },
  activated() {
    this.getPage();
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportManager}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}`;
    },
    getPage() {
      this.$axios
        .post(api.getManagerPage, this.requestData)
        .then(res => {
          this.total = res.data.data.total;
          let list = res.data.data.list;
          this.tableData = list;
        })
        .catch(errorHandler("获取物资列表失败"));
    },
    deleteLine(code) {
      this.$axios
        .post(api.deleteManagerByCodes, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("删除成功");
            this.selectionArr = [];
            this.getPage();
          }
        })
        .catch(errorHandler("删除失败"));
    },
    toAddPage() {
      this.$router.push({
        name: "material-manage-add"
      });
    },
    goToModifyPage(code) {
      this.$router.push({
        path: `material_manage_modify/${code}`
      });
    },
    searchKey(v) {
      this.requestData.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.requestData.pageNum = data[0];
      this.requestData.pageSize = data[1];
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    deleteSelection() {
      if (this.selectionArr.length === 0) {
        nAlert("请先选择需要删除的物资");
        return false;
      } else {
        this.$confirm("是否确认删除物资？", "提示")
          .then(() => {
            this.deleteLine(this.selectionArr);
          })
          .catch(() => {
            console.log("取消删除");
          });
      }
    },
    onUploadSuccess(data) {
      if (data.retCode == 1) {
        nSuccess("导入成功");
        this.pageSize = 10;
        this.pageNum = 1;
        this.getPage();
      } else {
        errorHandler("导入失败")(data);
      }
    }
  }
};
</script>


<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/view/MaterialManagement/MaterialManage/MaterialManage.vue